export default __webpack_public_path__ + "static/media/gallery6.30943af9.jpg";